import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import CloseIcon from "@mui/icons-material/Close";

const ChatbotHeader = ({
  chatbotAppearance,
  chatbotSettings,
}: {
  chatbotAppearance: any;
  chatbotSettings: any;
}) => {
  const headerFontSettings = {
    color: chatbotAppearance?.["cuvo-chatbot-header-text-color"],
    fontFamily: chatbotAppearance?.["cuvo-chatbot-header-text-font-family"],
    fontWeight: chatbotAppearance?.["uvo-chatbot-header-text-font-weight"],
    fontStyle: chatbotAppearance?.["cuvo-chatbot-header-text-font-style"],
    fontSize: chatbotAppearance?.["cuvo-chatbot-header-text-font-size"],
  };

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      sx={{
        padding: "0 10px",
      }}
    >
      <Grid item xs={6}>
        <Typography
          sx={{
            mixBlendModeode: "difference",
            ...headerFontSettings,
          }}
        >
          {chatbotSettings.name}
        </Typography>
      </Grid>
      <Grid item xs={6} textAlign="right">
        <IconButton>
          <CloseIcon
            sx={{
              color: chatbotAppearance?.["cuvo-chatbot-header-text-color"],
            }}
          />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default ChatbotHeader;
